

import { config } from '../../../config.js';

export const API_MSHospitalBaseUrl = config.API_MS_HOSPITAL_BASE_URL;
export const API_UserManageMentUrl = config.API_MS_AUTHORIZATION_URL;


// export const API_MSHospitalBaseUrl = "https://hms-devapi.mocerohealth.in/";

// export const API_UserManageMentUrl = "https://localhost:7137/";
// export const API_UserManageMentUrl = "http://localhost:5176/";

// export const API_UserManageMentUrl =
//   "https://mopuserapitest.convenientcare.life/";

// export const API_UserManageMentUrl = "https://demouserapi.convenientcare.life/";

// export const API_UserManageMentUrl = "https://mopuserapi.convenientcare.life/";

// export const API_UserManageMentUrl ="https://mopauthorizationhmsapi.convenientcare.life/";

// export const API_UserManageMentUrl ="https://medwayauthorizationtestapi.convenientcare.life/";

